import _ from 'underscore';
import Promise from 'bluebird';

import config from 'src/config';

class SettingsMicroSiteConfigCtrl {
  constructor($scope, $state, $stateParams, $q, microSiteConfigService, organizationService, sdkUtils, alertService, modalService, venueService, eventService) { //eslint-disable-line
    this._$scope = $scope;
    this._$state = $state;
    this._$stateParams = $stateParams;
    this._organizationService = organizationService;
    this._microSiteConfigService = microSiteConfigService;
    this._sdkUtils = sdkUtils;
    this._alertService = alertService;
    this._eventService = eventService;
    this._$q = $q;

    this.themes = [{
      key: 'Light',
      value: 'theme-light'
    }, {
      key: 'Dark',
      value: 'theme-dark'
    }];

    this.microSiteConfigForm = {
      backgroundColor: '#000000',
      contentBackgroundColor: '#000000'
    };

    this.getSiteUrl = function () {
      if (!this.microSiteConfig) return '';

      return `${config.WIDGET_BASE_URL}/s/${this.microSiteConfig.id}`;
    };

    const promises = [
      venueService.getCurrentVenues()
    ];

    if (this._$stateParams.id) {
      this.editMode = true;

      promises.push(this.getPromoteWebsiteById(this._$stateParams.id));
    }

    this.getBackgroundImageClass = function () {
      const classes = {};

      if (this.microSiteConfigForm.repeatBackgroundHorizontally && !this.microSiteConfigForm.repeatBackgroundVertically) {
        classes['repeat-bg-horizontal'] = true;
      } else if (this.microSiteConfigForm.repeatBackgroundHorizontally && !this.microSiteConfigForm.repeatBackgroundHorizontally) {
        classes['repeat-bg-vertical'] = true;
      } else if (this.microSiteConfigForm.repeatBackgroundHorizontally && this.microSiteConfigForm.repeatBackgroundHorizontally) {
        classes['repeat-bg-both'] = true;
      }

      return classes;
    };

    this.loading = true;

    $q.all(promises)
      .then(results => {
        this.venues = results[0];

        this.loading = false;

        if (this.editMode) {
          this.microSiteConfig = results[1];

          this.microSiteConfigForm = {
            name: this.microSiteConfig.name,
            theme: this.microSiteConfig.theme,
            venues: this.microSiteConfig.venues && this.microSiteConfig.venues.length ? _.filter(this.venues, venue => this.microSiteConfig.venues.indexOf(venue.id) >= 0) : null,
            bannerImage: this.microSiteConfig.bannerImage,
            bannerImageHeight: this.microSiteConfig.bannerImageHeight,
            backgroundImage: this.microSiteConfig.backgroundImage,
            backgroundColor: this.microSiteConfig.backgroundColor,
            contentBackgroundColor: this.microSiteConfig.contentBackgroundColor,
            repeatBackgroundHorizontally: this.microSiteConfig.repeatBackgroundHorizontally,
            repeatBackgroundVertically: this.microSiteConfig.repeatBackgroundVertically
          };

          if (this.microSiteConfig.events && this.microSiteConfig.events.length) {
            Promise.map(this.microSiteConfig.events, (eventId) => {
                return this._eventService.readById(eventId);
              })
              .then(eventResults => {
                this.events = [];

                eventResults.forEach(result => {
                  this.events.push(result);

                  this.microSiteConfigForm.events = _.filter(this.events, event => this.microSiteConfig.events.indexOf(event.id) >= 0);
                });
              });
          }
        }
      })
      .catch(response => {
        this.loading = false;

        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  searchEvents(search) { //eslint-disable-line
    const promises = [];

    this.venues.forEach(venue => {
      promises.push(this._eventService.listByVenueId(venue.id, {
        name: search
      }));
    });

    return this._$q.all(promises)
      .then(results => {
        let events = [];

        results.forEach(result => {
          events = events.concat(result);
        });

        this.events = events;
      });
  }

  getPromoteWebsiteById(id) {
    return this._microSiteConfigService.readById(id);
  }

  savePromoteWebsite(form, $event) {
    if ($event) $event.preventDefault();

    this.submitted = true;

    if (!form.$valid) return;

    this.submitted = false;
    this.saving = true;

    const currentUserOrganization = this._organizationService.getCurrentOrganization();

    let promise;

    const data = {
      name: this.microSiteConfigForm.name,
      theme: this.microSiteConfigForm.theme || 'theme-light',
      bannerImage: this.microSiteConfigForm.bannerImage,
      bannerImageHeight: this.microSiteConfigForm.bannerImageHeight,
      backgroundImage: this.microSiteConfigForm.backgroundImage,
      backgroundColor: this.microSiteConfigForm.backgroundColor,
      contentBackgroundColor: this.microSiteConfigForm.contentBackgroundColor,
      repeatBackgroundHorizontally: this.microSiteConfigForm.repeatBackgroundHorizontally,
      repeatBackgroundVertically: this.microSiteConfigForm.repeatBackgroundVertically,
      venueIds: this.microSiteConfigForm.venues && this.microSiteConfigForm.venues.length ? this.microSiteConfigForm.venues.map(venue => venue.id) : null,
      eventIds: this.microSiteConfigForm.events && this.microSiteConfigForm.events.length ? this.microSiteConfigForm.events.map(event => event.id) : null
    };

    if (!this.microSiteConfig) {
      promise = this._microSiteConfigService.createByOrganizationId(currentUserOrganization.id, data);
    } else {
      promise = this._microSiteConfigService.updateByIdAndOrganizationId(this.microSiteConfig.id, currentUserOrganization.id, data);
    }

    promise
      .then(() => {
        this.saving = false;
        this.submitted = false;

        if (!this.editMode) {
          this._$state.go('app.organization.settings.microSiteConfigs');
        }
      })
      .catch(response => {
        this.saving = false;
        this.submitted = false;

        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }
}

SettingsMicroSiteConfigCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  'jsSdk.microSiteConfig',
  'organizationService',
  'jsSdk.utils',
  'alertService',
  'modalService',
  'venueService',
  'jsSdk.event'
];

export default SettingsMicroSiteConfigCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsMicroSiteConfigEdit/settingsMicroSiteConfigEditCtrl.js